const clearFilters = {
    clearFilters: document.getElementById("clearFilters"),

    init() {
       this.clearFilter();

    },
    clearFilter() {
        if (this.clearFilters) {
          let link = window.location
          this.clearFilters.addEventListener("click", () => {
            window.location.replace(link.origin + link.pathname)
          })
        }
      },

}

export default clearFilters;